<template>
  <v-card class="mx-auto" max-width="400" v-if="mapSrc">
    <v-img
      class="white--text align-end"
      height="200px"
      :src="mapSrc"
    >
      <v-card-title class="map-title">{{ mapName }}</v-card-title>
    </v-img>

     <v-card-text class="text--primary" v-if="message">{{ message }}</v-card-text>

  </v-card>
</template>

<script>
import { bus } from "../main";
import countries from '../countries.json';

export default {
  name: "FlagCard",
  data: () => ({
    currentCountry: null,
    mapSrc: null,
    mapName: null,
    message: null
  }),
  created() {
    bus.$on("changeCountry", (country, currency, recommendedTip, rate) => {
      this.currentCountry = country;
      this.mapSrc = '/img/flags/'+countries[country].mapSrc;
      this.mapName = countries[country].countryName[this.$i18n.locale];
      this.message = countries[country].message[this.$i18n.locale];
    });
    bus.$on("refreshCountry", () => {
        if(null !== this.currentCountry) {
            this.mapName = countries[this.currentCountry].countryName[this.$i18n.locale];
            this.message = countries[this.currentCountry].message[this.$i18n.locale];
        }
    });    
  },
};
</script>

<style>
    .map-title {
        text-shadow: 2px 2px 3px #777;
    }
</style>